/**
 * Form values for the add/edit item dialog in the goods receiving wizard.
 * This form manages local state (not sent directly to the API).
 * The actual API submission uses CompleteReceiptItemDto.
 */
export interface AddItemFormData {
  productName: string;
  quantity: string;
  unit: string;
  batchNumber: string;
  expiryDate: string;
  /**
   * True for shelf-stable products without HACCP expiry (sugar, salt, honey).
   * Mutually exclusive with expiryDate — the traceability step enforces this
   * via the "Senza scadenza" toggle and the backend re-checks XOR on submit.
   */
  hasNoExpiry: boolean;
  /**
   * True for loose produce (ortofrutta) delivered without its own lot number.
   * Prefills batchNumber with a DDT-derived reference; independent of hasNoExpiry.
   */
  isLooseProduce: boolean;
  isDamaged: boolean;
  isTemperatureNonCompliant: boolean;
  isHygieneNonCompliant: boolean;
  unitPrice: string;
  lineTotal: string;
  currency: string;
  labelPhotos: File[];
}

export function getDefaultFormValues(): AddItemFormData {
  return {
    productName: '',
    quantity: '',
    unit: '',
    batchNumber: '',
    expiryDate: '',
    hasNoExpiry: false,
    isLooseProduce: false,
    isDamaged: false,
    isTemperatureNonCompliant: false,
    isHygieneNonCompliant: false,
    unitPrice: '',
    lineTotal: '',
    currency: 'EUR',
    labelPhotos: [],
  };
}
